import { Routes, Route } from "react-router-dom";
import TopNavbar from "./AppBar";
import Main from "./Main";
import Pricing from "./pricing";
import SignIn from "./Sign-In";
import Features from "./Features";
import AutoScaling from "./solutions/use-case";
import Financial from "./solutions/industry-case";
import Questions from "./FAQ";
import Solutions from "./solutions/solutions";
import BlogTemplate from "./solutions/blog-template";
import BlogCards from "./solutions/blog";

const RoutesComponent = () => {
  return (
    <>
      <TopNavbar />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/get-started" element={<SignIn />} />
        <Route path="/FAQs" element={<Questions />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/industry/*" element={<Financial />} />
        <Route path="/use-case/*" element={<AutoScaling />} />
        <Route path="/blog/*" element={<BlogTemplate />} />
        <Route path="/blogs" element={<BlogCards />} />
      </Routes>
    </>
  );
};

export default RoutesComponent;
